import { useTranslation } from "react-i18next";
import React from "react";
import customerServiceIcon from "assets/icons/customer-service.svg";

function AboutUsPageList() {

	const { t } = useTranslation();

	const elements = t("aboutUsPage.list.elements", { returnObjects: true }) as string[]

	return (
		<div className="container">
			<div className="flex flex-col gap-4 text-black mt-20 lg:mt-10">
				<div className="text-3xl font-medium leading-[48px]">
					{ t("aboutUsPage.list.title") }
				</div>
				<div className="grid grid-cols-2">
					<ul>
						{
							elements.map((element, index) =>
								<li key={ index } className="flex mb-2">
									<div className="bg-emerald-600 aspect-square h-10 flex justify-center items-center text-white rounded-full z-[1]">
										{ index + 1 }
									</div>
									<div className="bg-gradient-to-r from-emerald-500 to-transparent text-white ml-[-20px] z-[0] pl-7 pr-32 flex items-center whitespace-nowrap">
										{ element }
									</div>
								</li>
							)
						}
					</ul>
					<div className="hidden sm:flex justify-end lg:justify-center">
						<img
							src={ customerServiceIcon }
							alt="CUSTOMER_SERVICE"
							className="h-52"
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

export default AboutUsPageList;